import { render } from "./DynamicGrid.vue?vue&type=template&id=21d05885"
import script from "./DynamicGrid.vue?vue&type=script&lang=js"
export * from "./DynamicGrid.vue?vue&type=script&lang=js"

import "./DynamicGrid.vue?vue&type=style&index=0&id=21d05885&lang=css"

import exportComponent from "D:\\projects\\mitool\\MITOOL\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__